import { compose, defaultProps, withHandlers, withProps } from 'recompose'
import { connect } from 'react-redux'
import { applySpec } from 'ramda'
import { updateForm, setUser } from '../../actions'
import { withTheme } from 'modules/util'
import { Form } from '../../selectors'
import signInTheme from './theme.scss'
import { invalid } from './utils'

function mapStateToProps(state) {
  return {
    email: Form.email(state)
  }
}

const path =
  window.location.pathname === '/signin' ? '/' : window.location.pathname

const updateEmail = props => email => props.updateForm({ email})


const submitForm = ({ email, ...props }) => () =>
  props.setUser({
    email,
    authenticated: true
  })

export default compose(
  connect(mapStateToProps, { updateForm, setUser }),
  defaultProps({
    email: '',
    path
  }),
  withProps(applySpec({ invalid })),
  withTheme(signInTheme),
  withHandlers({
    submitForm,
    updateEmail
  })
)



// WEBPACK FOOTER //
// ./client/modules/user/components/SignIn/enhancers.js